var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accounts-list"},[(_vm.folders)?_c('v-list',{staticClass:"pb-0 pt-0",attrs:{"light":""}},[_vm._l((_vm.sortedFolders),function(folder){return [_c('account',{key:folder.id,attrs:{"folder":folder,"edit-mode":_vm.editMode}}),_c('v-divider',{staticClass:"accounts-list__divider"})]})],2):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39bb2894","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/list/Accounts.vue
// module id = null
// module chunks = 